import React from 'react';
import PropTypes from 'prop-types';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

export default function FormikSelect({ label, ...other }) {
  return (
    <FormControl>
      {label && (
        <InputLabel shrink>
          {label}
        </InputLabel>
      )}
      <NativeSelect
        {...other}
      />
    </FormControl>
  );
}

FormikSelect.propTypes = {
  form: PropTypes.object,
  name: PropTypes.string,
};
